const CUSTOMER_KEY_REGEX = /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/i;

export default function isValidCustomerKey(value) {
  return !value || CUSTOMER_KEY_REGEX.test(value);
}
